"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAgendaSlotAssistantModeApiResponseSchema = exports.updateAgendaSlotAssistantModeApiPayloadSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("./agenda-slot");
exports.updateAgendaSlotAssistantModeApiPayloadSchema = zod_1.z.object({
    withAssistant: zod_1.z.boolean().nullable().optional(),
    forceWithoutAssistant: zod_1.z.boolean().optional(),
    type: agenda_slot_1.agendaSlotTypeSchema.optional(),
});
exports.updateAgendaSlotAssistantModeApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        type: zod_1.z.literal('agenda-slots'),
        attributes: zod_1.z.object({
            type: zod_1.z.string(),
            startAt: zod_1.z.coerce.date(),
            endAt: zod_1.z.coerce.date(),
            periodOfTheDay: zod_1.z.string(),
            withAssistant: zod_1.z.boolean(),
            forceWithoutAssistant: zod_1.z.boolean().optional().default(false),
            withAssistantInferred: zod_1.z.boolean().optional().default(false),
            retrocessionRate: zod_1.z.number(),
        }),
    }),
});
